/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { CheckCircleIcon, MinusCircleIcon } from "@heroicons/react/outline";
import { XIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";

export type ToastNottficationtype = {
  massgesKey: string;
  title?: string;
  type?: "success" | "error";
};

export default function ToastNottfication({
  massgesKey,
  title,
  type,
}: ToastNottficationtype) {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setShow(false);
    }, 3000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <div
      aria-live="assertive"
      className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-[1000]"
    >
      <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
        {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
        <Transition
          show={show}
          as={Fragment}
          enter="transform ease-out duration-300 transition"
          enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enterTo="translate-y-0 opacity-100 sm:translate-x-0"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
            <div className="p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  {type === "success" ? (
                    <CheckCircleIcon
                      className="h-6 w-6 ` text-green-400`"
                      type="success"
                      aria-hidden="true"
                    />
                  ) : (
                    <MinusCircleIcon
                      className="h-6 w-6 ` text-red-400`"
                      type="error"
                      aria-hidden="true"
                    />
                  )}
                </div>
                <div className="ml-3 rtl:mr-3 w-0 flex-1 pt-0.5">
                  {!!title && (
                    <p className="text-sm font-medium text-gray-900">{title}</p>
                  )}
                  <p className="mt-1 ml-3 rtl:mr-3 text-sm text-gray-500">
                    {i18n.exists(`toast.${massgesKey}`)
                      ? t(`toast.${massgesKey}`)
                      : massgesKey}
                  </p>
                </div>
                <div className="ml-4 flex-shrink-0 flex">
                  <button
                    className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                    onClick={() => {
                      setShow(false);
                    }}
                  >
                    <span className="sr-only">Close</span>
                    <XIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
}
